import { render, staticRenderFns } from "./DashboardDefault.vue?vue&type=template&id=08d0d1b8&scoped=true&lang=pug&"
import script from "./DashboardDefault.vue?vue&type=script&lang=js&"
export * from "./DashboardDefault.vue?vue&type=script&lang=js&"
import style0 from "./DashboardDefault.vue?vue&type=style&index=0&id=08d0d1b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d0d1b8",
  null
  
)

export default component.exports